import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const SettlementCustomerOpeningBalancesDetailMain = () => {
    const { watch } = useFormContext();
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        disabled
                        fieldName="documentNumber"
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName="documentDate"
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFTextInput title={t("Comment")} fieldName="comment" />
                </Col>
                <Col sm={6}>

                    <NFLookupCompany
                        title={t("Company")}
                        fieldName="companyId"

                        required={true}
                    />
                </Col>
            </Row>
        </>
    );
};
